import { render, staticRenderFns } from "./CoozzyModal.vue?vue&type=template&id=583e5941&scoped=true"
import script from "./CoozzyModal.vue?vue&type=script&lang=js"
export * from "./CoozzyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e5941",
  null
  
)

export default component.exports